import { config } from '../../../config.js';

export const API_MSHospitalBaseUrl = config.API_MS_HOSPITAL_BASE_URL;
export const API_MSInventoryUrl = config.API_MS_INVENTORY_URL;

// export const API_MSHospitalBaseUrl =
//   "https://dhanwanthralayatestapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://localhost:7054/";
// export const API_MSInventoryUrl = "http://localhost:5049/";

// export const API_MSInventoryUrl =
//   "https://inventorydevapi.convenientcare.life/";

// export const API_MSInventoryUrl ="https://inventorymedwayapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://inventorymedwayapitest.convenientcare.life/";

// export const API_MSInventoryUrl = "https://icareinventoryapi.mocerohealth.com/";

// export const API_MSInventoryUrl = "https://icareinventoryapitest.convenientcare.life/";

// export const API_MSInventoryUrl ="https://naadiinvapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://demoinvapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://dashinvapi.convenientcare.life/";

// export const API_MSInventoryUrl ="https://shabdhaminvapitest.convenientcare.life/";

// export const API_MSInventoryUrl = "https://shabdhaminventoryapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://inventoryapi.medwayhospitals.com/";

// export const API_MSInventoryUrl = "https://inventoryapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://magnatestinventoryapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://magnainventoryapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://amminventoryapi.convenientcare.life/";

// export const API_MSInventoryUrl = "https://wellcubeinvtestapi.mocerohealth.com/";

// export const API_MSInventoryUrl = "https://sutinventorytestapi.mocerohealth.com/";

// export const API_MSInventoryUrl = "https://careinventoryapi.curola-app.com/";

// export const API_MSInventoryUrl = "https://inventoryapi.mymedbling.com/";

